// extracted by mini-css-extract-plugin
export default {"body":"Presupuestos_body__cwFrK","content":"Presupuestos_content__-Wqwc","menuGroup":"Presupuestos_menuGroup__6cUjW"};